// extracted by mini-css-extract-plugin
export default {"emptyBlock":"style_emptyBlock__jaEps"};